import { TrendingUp, Film } from "lucide-react";

import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface TopCreative {
  title: string;
  format: string;
  platform: string;
  age: string;
  ctr: number;
}

export function TopPerformingCreatives({ items, blurred }: { items: TopCreative[]; blurred?: boolean }) {
  return (
    <Card className={cn("flex flex-col flex-1 min-w-0", blurred && "blur-[1px] select-none pointer-events-none")}>
      <CardHeader className="flex flex-row items-center gap-2">
        <div className="rounded-md bg-success/10 p-2">
          <TrendingUp className="size-5 text-success" strokeWidth={2.5} />
        </div>
        <CardTitle className="text-base font-semibold">Top Performing Creatives</CardTitle>
      </CardHeader>
      <CardContent className="pt-0 space-y-4">
        {items.map((item) => (
          <div key={item.title} className="flex items-center gap-3">
            <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-muted">
              <Film className="size-5 text-foreground/70" strokeWidth={2.5} />
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-semibold text-foreground truncate">{item.title}</p>
              <p className="text-xs text-muted-foreground">
                {item.format} · {item.platform} · {item.age}
              </p>
            </div>
            <p className="text-sm font-semibold text-success shrink-0">{Math.round(item.ctr)}%</p>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
